import { Component } from '@angular/core';
import { HouseDetailsBaseComponent } from './../common-theme/index';

@Component({
  selector: 'app-house-details',
  templateUrl: './house-details.component.html',
  styleUrls: ['./house-details.component.scss']
})

export class HouseDetailsComponent extends HouseDetailsBaseComponent {
}



// WEBPACK FOOTER //
// ./src/app/houses/house-details.component.ts